define(['jQuery', 'toolkit/b-toolkit/b-toolkit', '../notify/notify'], (
    $,
    toolkit,
    BNotify,
) => {
    const MAX_STACK = 10;
    const HIDE_TIME = 10;

    return toolkit.create('notify-manager', {
        init() {
            this._stack = [];

            // eslint-disable-next-line prefer-rest-params
            toolkit['b-toolkit'].fn.init.apply(this, arguments);
        },

        _delete(notify) {
            const index = this._stack.indexOf(notify);
            let el;

            if (index !== -1) {
                el = notify.el;

                notify.destroy();
                $(el).remove();

                this._stack.splice(index, 1);
            }

            if (!this._stack.length) {
                this.$el.hide();
            }
        },

        add(settings) {
            settings || (settings = {});

            const message = settings.message;
            const link = settings.link;
            const type = settings.type || 'success';

            if (this._stack.length === MAX_STACK) {
                this._stack.shift().destroy();
            }

            const notify = new BNotify({
                renderMode: 'replace',
                el: $('<div/>'),

                data: {
                    mods: [type],
                    message,
                    link,
                    html: settings.html,
                },
            });

            setTimeout(
                function(notify) {
                    return function() {
                        this._delete(notify);
                    }.bind(this);
                }.call(this, notify),
                HIDE_TIME * 1000,
            );

            notify.render();

            notify.$el.appendTo(this.$el);

            this._stack.push(notify);

            this.$el.show();

            notify.on('close', () => {
                this._delete(notify);
            });

            return notify;
        },

        destroy() {
            // eslint-disable-next-line prefer-rest-params
            toolkit['b-toolkit'].fn.destroy.apply(this, arguments);
        },
    });
});
